'use client'

import { isMobileDevice } from '@/core/lib/utils/is-mobile-device'
import { dateService } from '@/core/services/date'
import { PageTracking } from '@/meta/components/page-tracking'
import { HeroUIProvider } from '@heroui/react'
import { ToastProvider } from '@heroui/toast'
import { Locale, NextIntlClientProvider } from 'next-intl'
import { useRegisterSW } from './use-register-sw'
import { WebVitals } from './web-vitals'

export function Providers({
  children,
  locale,
  messages,
}: {
  children: React.ReactNode
  locale: Locale
  messages: Record<string, string>
}) {
  useRegisterSW()
  const toastProvider = <ToastProvider placement='bottom-right' />
  const webVitals = <WebVitals />
  const pageTracking = <PageTracking />
  const isMobile = isMobileDevice()

  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone={dateService.timeZone}
    >
      <HeroUIProvider disableAnimation={isMobile}>
        {toastProvider}
        {webVitals}
        {pageTracking}
        {children}
      </HeroUIProvider>
    </NextIntlClientProvider>
  )
}
